import startup from '@topomatic/tap/src/main';
import { installContext } from '@topomatic/tap/src/l10n';
import Login from './files/Login.vue';
import FilesView from './files/FilesView.vue';
import ShareView from './files/ShareView.vue';
import FilesApi from './api';

installContext(require.context('./locales'));

startup('#app', {
    '': FilesView,
    share: ShareView,
    login: Login,
}, new FilesApi());
